// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'IOVF', 'IOVF Fallback'"},"className":"__className_a3d78d","variable":"__variable_a3d78d"};